import { Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';
import { AuthConfig, OAuthService } from 'angular-oauth2-oidc';
import { Location } from '@angular/common';
import { UserService } from '~services/user/user.service';
import { isRenderingForMobileApp } from 'src/constants';
import { Router } from '@angular/router';
import { TrxService } from '~services/trx/trx.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  userId: string;

  constructor(
    private oauthService: OAuthService,
    private location: Location,
    private userService: UserService,
    private trxService: TrxService,
    private router: Router,
  ) {}

  async initialize() {
    this.oauthService.configure(this.authConfig);
    await this.oauthService.loadDiscoveryDocumentAndTryLogin();
    this.oauthService.setupAutomaticSilentRefresh();

    if (!this.oauthService.hasValidAccessToken() && isRenderingForMobileApp) {
      return this.oauthService.initLoginFlow(this.location.path());
    }

    const userInfo = await this.userService.getUserInfo().toPromise();
    this.userId = userInfo.id;

    await this.trxService.setCustomerId(userInfo.id);

    if (
      this.oauthService.state &&
      this.oauthService.state !== 'undefined' &&
      this.oauthService.state !== 'null'
    ) {
      let stateUrl = this.oauthService.state;
      if (stateUrl.startsWith('/') === false) {
        stateUrl = decodeURIComponent(stateUrl);
      }
      await this.router.navigateByUrl(stateUrl);
    }
  }

  authConfig: AuthConfig = {
    // Url of the Identity Provider
    issuer: environment.zipIdp.issuer,

    // URL of the SPA to redirect the user to after login
    redirectUri: `${window.location.origin}/au/giftcards/`,

    clientId: environment.zipIdp.clientId,

    responseType: 'code',

    scope: 'openid profile offline_access',

    showDebugInformation: true,
  };
}
